import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const CustomBannerTransparent = ({ orderNumber, cartId, onSelect, isSelected }) => {
  const { t } = useTranslation();



  const handleSelect = () => {
  if (onSelect) {
    onSelect(cartId, !isSelected); 
  }
};
  return (
    <div
      className={`flex w-full items-center justify-between p-1 rounded-md mb-2 ${
        isSelected ? "bg-transparent text-black" : "text-black"
      }`}
    >
      <div className="font-bold">
        <span className="text-xs text-gray-800 lg:text-lg">{t("orderNumber")} :</span>
        <span className="text-xs text-gray-800 lg:text-base"> {orderNumber}</span>
      </div>

      <div className="flex items-center gap-2 cursor-pointer"
      onClick={handleSelect}
      >
        <div
          className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 ${
            isSelected ? "bg-green-600 border-green-600" : "bg-white border-gray-300"
          }`}
        >
          {isSelected && <CheckIcon className="w-4 h-4 text-white" />}
          <input
            type="checkbox"
            className="absolute inset-0 opacity-0 cursor-pointer"
            checked={isSelected}
          />
        </div>
        <span className="text-sm font-medium text-black" >
          {t("SelectOrder")}
        </span>
      </div>
    </div>
  );
};



export default CustomBannerTransparent;
